import L from 'leaflet';

export const CustomCRS = Object.assign(L.CRS.Simple, { transformation: L.transformation(1, 0, 1, 0) });
